module.exports = __webpack_public_path__ + "static/media/trueroyal.e6156a25.jpg";